export default __webpack_public_path__ + "static/media/location.f5a0282e.svg";